// import React, { useState, useEffect, useRef } from "react";
// import Button from "../../Buttons/Button";

// const sizeClasses = {
//   sm: "px-3 py-1.5",
//   md: "px-3 py-2",
//   lg: "px-4 py-2.5",
//   xl: "px-5 py-3",
// };

// const fontSizeClasses = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const iconSizeClasses = {
//   sm: "!text-[14px]",
//   md: "!text-[14px]",
//   lg: "!text-[15px]",
//   xl: "!text-[15px]",
// };

// const CustomMonthPicker = ({
//   selected,
//   onChange = () => {},
//   placeholder = "Select a month",
//   size = "md",
//   rounded = "rounded",
//   maxDate,
//   minDate,
//   range = false,
//   disabled = false,
// }) => {
//   // Parse month helper - converts date to first day of month
//   const parseMonth = (dateInput) => {
//     if (!dateInput) return null;

//     if (typeof dateInput === "string") {
//       // Handle ISO datetime strings
//       if (dateInput.includes("T")) {
//         const datePart = dateInput.split("T")[0];
//         const [year, month] = datePart.split("-").map(Number);
//         return new Date(year, month - 1, 1);
//       }

//       // Handle date-only strings like "2025-02-01"
//       if (dateInput.match(/^\d{4}-\d{2}-\d{2}$/)) {
//         const [year, month] = dateInput.split("-").map(Number);
//         return new Date(year, month - 1, 1);
//       }
//     }

//     // Handle Date objects - normalize to first day of month
//     if (dateInput instanceof Date && !isNaN(dateInput)) {
//       return new Date(dateInput.getFullYear(), dateInput.getMonth(), 1);
//     }

//     // Fallback for other formats
//     const date = new Date(dateInput);
//     if (isNaN(date.getTime())) return null;
//     return new Date(date.getFullYear(), date.getMonth(), 1);
//   };

//   const [isOpen, setIsOpen] = useState(false);
//   const [currentYear, setCurrentYear] = useState(
//     parseMonth(
//       range ? selected?.from || selected?.start : selected
//     )?.getFullYear() || new Date().getFullYear()
//   );
//   const [selectedMonth, setSelectedMonth] = useState(parseMonth(selected));
//   const dropdownRef = useRef(null);

//   // Range mode states
//   const [fromMonth, setFromMonth] = useState(
//     parseMonth(range ? selected?.from || selected?.start : null)
//   );
//   const [toMonth, setToMonth] = useState(
//     parseMonth(range ? selected?.to || selected?.end : null)
//   );
//   const [selectionMode, setSelectionMode] = useState(fromMonth ? "to" : "from");

//   const [showYearsList, setShowYearsList] = useState(false);
//   const [tempSelectedMonth, setTempSelectedMonth] = useState(null);

//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const isMonthValid = (year, monthIndex) => {
//     const monthDate = new Date(year, monthIndex, 1);
//     const minMonthDate = minDate
//       ? new Date(minDate.getFullYear(), minDate.getMonth(), 1)
//       : null;
//     const maxMonthDate = maxDate
//       ? new Date(maxDate.getFullYear(), maxDate.getMonth(), 1)
//       : null;

//     if (minMonthDate && monthDate < minMonthDate) return false;
//     if (maxMonthDate && monthDate > maxMonthDate) return false;
//     if (range && selectionMode === "to" && fromMonth && monthDate < fromMonth)
//       return false;
//     return true;
//   };

//   useEffect(() => {
//     if (selected) {
//       setFromMonth(
//         parseMonth(range ? selected?.from || selected?.start : null)
//       );
//       setToMonth(parseMonth(range ? selected?.to || selected?.end : null));
//     }
//   }, [selected]);

//   useEffect(() => {
//     if (!range) {
//       const parsedMonth = parseMonth(selected);
//       if (
//         parsedMonth &&
//         isMonthValid(parsedMonth.getFullYear(), parsedMonth.getMonth())
//       ) {
//         setSelectedMonth(parsedMonth);
//         setCurrentYear(parsedMonth.getFullYear());
//       }
//     } else {
//       const parsedFromMonth = parseMonth(selected?.from || selected?.start);
//       const parsedToMonth = parseMonth(selected?.to || selected?.end);

//       if (parsedFromMonth) {
//         setFromMonth(parsedFromMonth);
//         setSelectionMode(parsedToMonth ? "from" : "to");
//         setCurrentYear(parsedFromMonth.getFullYear());
//       }

//       if (parsedToMonth) {
//         setToMonth(parsedToMonth);
//         if (selectionMode === "to") {
//           setCurrentYear(parsedToMonth.getFullYear());
//         }
//       }
//     }
//   }, [selected, minDate, maxDate, range]);

//   // Modified handleMonthClick to perform the selection immediately
//   const handleMonthClick = (monthIndex) => {
//     try {
//       const newSelectedMonth = new Date(currentYear, monthIndex, 1);

//       if (isMonthValid(currentYear, monthIndex)) {
//         if (!range) {
//           // For single month mode - select immediately and close
//           setTempSelectedMonth(newSelectedMonth);
//           setSelectedMonth(newSelectedMonth);
//           onChange(newSelectedMonth);
//           setIsOpen(false);
//         } else {
//           // For range mode
//           if (selectionMode === "from") {
//             // Check if the new start month is after the current end month
//             if (toMonth && newSelectedMonth > toMonth) {
//               // Clear the end month if start month is after it
//               setToMonth(null);
//               setFromMonth(newSelectedMonth);
//               setSelectionMode("to");
//               onChange({ from: newSelectedMonth, to: null });
//             } else {
//               setFromMonth(newSelectedMonth);
//               setSelectionMode("to");
//               onChange({ from: newSelectedMonth, to: toMonth });
//             }
//           } else {
//             setToMonth(newSelectedMonth);
//             setSelectionMode("from");
//             onChange({ from: fromMonth, to: newSelectedMonth });
//             setIsOpen(false);
//           }
//           setTempSelectedMonth(newSelectedMonth);
//         }
//       }
//     } catch (error) {
//       console.error("Error creating month:", error);
//     }
//   };

//   // Remove the handleMonthDoubleClick function as it's no longer needed

//   const handlePrevYear = () => {
//     setCurrentYear(currentYear - 1);
//   };

//   const handleNextYear = () => {
//     setCurrentYear(currentYear + 1);
//   };

//   const handleThisMonthClick = () => {
//     const thisMonth = new Date();
//     const normalizedThisMonth = new Date(
//       thisMonth.getFullYear(),
//       thisMonth.getMonth(),
//       1
//     );
//     setTempSelectedMonth(normalizedThisMonth);
//     setCurrentYear(thisMonth.getFullYear());

//     if (!range) {
//       setSelectedMonth(normalizedThisMonth);
//       onChange(normalizedThisMonth);
//     } else {
//       if (selectionMode === "from") {
//         setFromMonth(normalizedThisMonth);
//         setSelectionMode("to");
//         onChange({ from: normalizedThisMonth, to: toMonth });
//       } else {
//         setToMonth(normalizedThisMonth);
//         setSelectionMode("from");
//         onChange({ from: fromMonth, to: normalizedThisMonth });
//       }
//     }
//     setIsOpen(false);
//   };

//   const handleDoneClick = () => {
//     if (!range) {
//       if (tempSelectedMonth) {
//         setSelectedMonth(tempSelectedMonth);
//         try {
//           if (typeof onChange === "function") {
//             onChange(tempSelectedMonth);
//           }
//         } catch (error) {
//           console.error("Error in onChange handler:", error);
//         }
//       }
//     } else {
//       if (tempSelectedMonth) {
//         if (selectionMode === "from") {
//           setFromMonth(tempSelectedMonth);
//           setSelectionMode("to");
//           onChange({ from: tempSelectedMonth, to: toMonth });
//         } else {
//           setToMonth(tempSelectedMonth);
//           setSelectionMode("from");
//           onChange({ from: fromMonth, to: tempSelectedMonth });
//           setIsOpen(false);
//         }
//       }

//       if (selectionMode === "to" && fromMonth && !tempSelectedMonth) {
//         setIsOpen(false);
//       }
//     }

//     setIsOpen(false);
//     setShowYearsList(false);
//   };

//   const handleClearClick = () => {
//     if (!range) {
//       setSelectedMonth(null);
//       onChange(null);
//     } else {
//       setFromMonth(null);
//       setToMonth(null);
//       setSelectionMode("from");
//       onChange({ from: null, to: null });
//     }
//     setIsOpen(false);
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (!isOpen) return;

//       switch (e.key) {
//         case "Escape":
//           setIsOpen(false);
//           break;
//         case "ArrowLeft":
//           if (!showYearsList) handlePrevYear();
//           break;
//         case "ArrowRight":
//           if (!showYearsList) handleNextYear();
//           break;
//         case "Enter":
//           if (showYearsList) {
//             setShowYearsList(false);
//             setIsOpen(true);
//           }
//           break;
//         default:
//           break;
//       }
//     };

//     document.addEventListener("keydown", handleKeyDown);
//     return () => document.removeEventListener("keydown", handleKeyDown);
//   }, [isOpen, showYearsList]);

//   const renderMonths = () => {
//     return months.map((month, index) => {
//       const monthDate = new Date(currentYear, index, 1);
//       const isCurrentMonth =
//         monthDate.getMonth() === new Date().getMonth() &&
//         monthDate.getFullYear() === new Date().getFullYear();

//       const isBeforeMinDate =
//         minDate &&
//         monthDate < new Date(minDate.getFullYear(), minDate.getMonth(), 1);
//       const isAfterMaxDate =
//         maxDate &&
//         monthDate > new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
//       const isBeforeFromMonth =
//         range && selectionMode === "to" && fromMonth && monthDate < fromMonth;

//       // For range mode
//       const isFromMonth =
//         range &&
//         fromMonth &&
//         monthDate.getMonth() === fromMonth.getMonth() &&
//         monthDate.getFullYear() === fromMonth.getFullYear();

//       const isToMonth =
//         range &&
//         toMonth &&
//         monthDate.getMonth() === toMonth.getMonth() &&
//         monthDate.getFullYear() === toMonth.getFullYear();

//       const isInRange =
//         range &&
//         fromMonth &&
//         toMonth &&
//         monthDate > fromMonth &&
//         monthDate < toMonth;

//       // For single month mode
//       const isSelectedMonth =
//         !range &&
//         tempSelectedMonth instanceof Date &&
//         !isNaN(tempSelectedMonth) &&
//         tempSelectedMonth.getMonth() === index &&
//         tempSelectedMonth.getFullYear() === currentYear;

//       return (
//         <div
//           key={index}
//           className={`leading-none flex items-center justify-center rounded-lg cursor-pointer p-2 text-center hover:bg-primary hover:text-white transition-colors ${
//             isSelectedMonth ? "bg-primary text-white" : ""
//           } ${isFromMonth ? "bg-primary text-white" : ""} ${
//             isToMonth ? "bg-primary text-white" : ""
//           } ${isInRange ? "bg-primary/20" : ""} ${
//             isCurrentMonth ? "border-[1px] border-primary" : ""
//           } ${
//             isBeforeMinDate || isAfterMaxDate || isBeforeFromMonth
//               ? "text-gray-300 cursor-not-allowed hover:bg-transparent hover:text-gray-300"
//               : ""
//           } text-sm`}
//           onClick={() =>
//             !isBeforeMinDate &&
//             !isAfterMaxDate &&
//             !isBeforeFromMonth &&
//             handleMonthClick(index)
//           }
//           // Removed onDoubleClick handler
//         >
//           {month.slice(0, 3)}
//         </div>
//       );
//     });
//   };

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (isOpen) {
//       if (!range) {
//         setTempSelectedMonth(selectedMonth);
//       } else {
//         setTempSelectedMonth(selectionMode === "from" ? fromMonth : toMonth);
//       }
//     }
//   }, [isOpen, selectedMonth, selectionMode, fromMonth, toMonth, range]);

//   const formatMonth = (date) => {
//     if (!date || !(date instanceof Date) || isNaN(date)) return "";
//     try {
//       return date.toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//       });
//     } catch (error) {
//       console.error("Error formatting month:", error);
//       return "";
//     }
//   };

//   const formatMonthRange = () => {
//     if (fromMonth && toMonth) {
//       return `${formatMonth(fromMonth)} - ${formatMonth(toMonth)}`;
//     } else if (fromMonth) {
//       return `${formatMonth(fromMonth)} - Select end month`;
//     } else {
//       return placeholder;
//     }
//   };

//   return (
//     <div className="relative w-full min-w-32" ref={dropdownRef}>
//       {/* MonthPicker Button */}
//       <button
//         className={`w-full border border-gray-300 flex justify-between items-center  ${
//           sizeClasses[size]
//         } ${fontSizeClasses[size]} ${rounded} ${
//           disabled
//             ? "bg-gray-200 text-gray-600 cursor-not-allowed"
//             : "bg-white hover:border-primary focus:border-primary focus:outline-none"
//         }`}
//         onClick={() => {
//           if (showYearsList) {
//             setShowYearsList(false);
//           }
//           setIsOpen(!isOpen);
//         }}
//         disabled={disabled}
//       >
//         <span
//           className={`line-clamp-1 text-left ${
//             (range ? fromMonth || toMonth : selectedMonth)
//               ? "text-black"
//               : "text-neutrals-500"
//           }`}
//         >
//           {range
//             ? formatMonthRange()
//             : selectedMonth
//             ? formatMonth(selectedMonth)
//             : placeholder}
//         </span>

//         <span
//           className={`material-icons transition-transform ${
//             iconSizeClasses[size]
//           } ${
//             (range ? fromMonth || toMonth : selectedMonth)
//               ? "cursor-pointer"
//               : ""
//           }
//           ${
//             disabled
//               ? "bg-gray-200 text-gray-600 cursor-not-allowed"
//               : "bg-white cursor-pointer"
//           }
//           `}
//           onClick={(e) => {
//             e.stopPropagation();
//             if (range) {
//               if (fromMonth || toMonth) {
//                 setFromMonth(null);
//                 setToMonth(null);
//                 setSelectionMode("from");
//                 onChange({ from: null, to: null });
//               }
//             } else {
//               if (selectedMonth) {
//                 setSelectedMonth(null);
//                 onChange(null);
//               }
//             }
//           }}
//         >
//           {(range ? fromMonth || toMonth : selectedMonth)
//             ? "close"
//             : "calendar_month"}
//         </span>
//       </button>

//       {/* Month Picker Dropdown */}
//       <div className="absolute z-[99] w-full min-w-64 max-w-68 mt-1">
//         {isOpen && (
//           <div className="bg-white border border-gray-200 rounded-lg shadow-lg select-none">
//             <div className="px-4 pt-3 flex justify-between items-center">
//               <div className="w-full flex items-center justify-between gap-1 border-[1px] border-neutrals-50 p-1">
//                 <Button
//                   type="icon"
//                   color="black"
//                   variant="text"
//                   size="sm"
//                   icon={"west"}
//                   onClick={handlePrevYear}
//                 />
//                 <div className="px-3">
//                   <Button
//                     variant="text"
//                     size="sm"
//                     color="black"
//                     title={currentYear.toString()}
//                     onClick={() => {
//                       if (showYearsList) {
//                         setShowYearsList(false);
//                         setIsOpen(true);
//                       } else {
//                         setShowYearsList(true);
//                         setIsOpen(false);
//                       }
//                     }}
//                   />
//                 </div>
//                 <Button
//                   type="icon"
//                   variant="text"
//                   size="sm"
//                   color="black"
//                   icon={"east"}
//                   onClick={handleNextYear}
//                 />
//               </div>
//             </div>

//             {range && (
//               <div className="px-4 pt-2">
//                 <div className="text-sm font-medium text-primary">
//                   {selectionMode === "from"
//                     ? "Select start month"
//                     : "Select end month"}
//                 </div>
//               </div>
//             )}

//             <div className="grid grid-cols-3 gap-2 px-4 py-4">
//               {renderMonths()}
//             </div>

//             <hr />
//             <div className="flex items-center justify-between px-4 py-4">
//               <Button
//                 variant="text"
//                 color="black"
//                 title="Clear"
//                 onClick={handleClearClick}
//               />
//               <div className="flex items-center gap-2">
//                 <Button
//                   variant="text"
//                   color="black"
//                   title="This Month"
//                   onClick={handleThisMonthClick}
//                 />
//                 <Button title="Done" size="md" onClick={handleDoneClick} />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Year selection panel */}
//         {showYearsList && (
//           <div className="absolute top-0 left-0 right-0 p-4 bg-white border border-gray-200 rounded-lg shadow-lg select-none">
//             <div className="flex justify-between gap-1 items-center mb-4">
//               <Button
//                 type="icon"
//                 size="xs-sm"
//                 icon={"west"}
//                 onClick={() => setCurrentYear(currentYear - 9)}
//               />
//               <span className="font-medium">
//                 {currentYear - 4} - {currentYear + 4}
//               </span>
//               <Button
//                 type="icon"
//                 size="xs-sm"
//                 icon={"east"}
//                 onClick={() => setCurrentYear(currentYear + 9)}
//               />
//             </div>
//             <div className="grid grid-cols-3 gap-4">
//               {Array.from({ length: 9 }, (_, i) => currentYear - 4 + i).map(
//                 (year) => (
//                   <Button
//                     key={year}
//                     title={year.toString()}
//                     variant={currentYear === year ? "outlined" : "text"}
//                     color={currentYear === year ? "primary" : "default"}
//                     onClick={() => {
//                       setCurrentYear(year);
//                       setShowYearsList(false);
//                       setIsOpen(true);
//                     }}
//                   />
//                 )
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CustomMonthPicker;

import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import Button from "../../Buttons/Button";

const sizeClasses = {
  sm: "px-3 py-1.5",
  md: "px-3 py-2",
  lg: "px-4 py-2.5",
  xl: "px-5 py-3",
};

const fontSizeClasses = {
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const iconSizeClasses = {
  sm: "!text-[14px]",
  md: "!text-[14px]",
  lg: "!text-[15px]",
  xl: "!text-[15px]",
};

const CustomMonthPicker = ({
  selected,
  onChange = () => {},
  placeholder = "Select a month",
  size = "md",
  rounded = "rounded",
  maxDate,
  minDate,
  range = false,
  disabled = false,
  shadow = false,
}) => {
  // Parse month helper - converts date to first day of month
  const parseMonth = (dateInput) => {
    if (!dateInput) return null;

    if (typeof dateInput === "string") {
      // Handle ISO datetime strings
      if (dateInput.includes("T")) {
        const datePart = dateInput.split("T")[0];
        const [year, month] = datePart.split("-").map(Number);
        return new Date(year, month - 1, 1);
      }

      // Handle date-only strings like "2025-02-01"
      if (dateInput.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month] = dateInput.split("-").map(Number);
        return new Date(year, month - 1, 1);
      }
    }

    // Handle Date objects - normalize to first day of month
    if (dateInput instanceof Date && !isNaN(dateInput)) {
      return new Date(dateInput.getFullYear(), dateInput.getMonth(), 1);
    }

    // Fallback for other formats
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return null;
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [currentYear, setCurrentYear] = useState(
    parseMonth(
      range ? selected?.from || selected?.start : selected
    )?.getFullYear() || new Date().getFullYear()
  );
  const [selectedMonth, setSelectedMonth] = useState(parseMonth(selected));
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const dropdownContainerRef = useRef(null);

  // Range mode states
  const [fromMonth, setFromMonth] = useState(
    parseMonth(range ? selected?.from || selected?.start : null)
  );
  const [toMonth, setToMonth] = useState(
    parseMonth(range ? selected?.to || selected?.end : null)
  );
  const [selectionMode, setSelectionMode] = useState(fromMonth ? "to" : "from");

  const [showYearsList, setShowYearsList] = useState(false);
  const [tempSelectedMonth, setTempSelectedMonth] = useState(null);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const isMonthValid = (year, monthIndex) => {
    const monthDate = new Date(year, monthIndex, 1);
    const minMonthDate = minDate
      ? new Date(minDate.getFullYear(), minDate.getMonth(), 1)
      : null;
    const maxMonthDate = maxDate
      ? new Date(maxDate.getFullYear(), maxDate.getMonth(), 1)
      : null;

    if (minMonthDate && monthDate < minMonthDate) return false;
    if (maxMonthDate && monthDate > maxMonthDate) return false;
    if (range && selectionMode === "to" && fromMonth && monthDate < fromMonth)
      return false;
    return true;
  };

  // Dynamic positioning logic
  useLayoutEffect(() => {
    if (
      (isOpen || showYearsList) &&
      buttonRef.current &&
      dropdownContainerRef.current
    ) {
      const updatePosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const dropdownRect =
          dropdownContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        // Calculate available space
        const spaceBelow = viewportHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;

        // Determine if dropdown should be below or above button
        const showBelow =
          spaceBelow >= Math.min(320, dropdownRect.height) ||
          spaceBelow >= spaceAbove;

        // Calculate left position
        let left = buttonRect.left + window.scrollX;
        // Adjust if dropdown would overflow right edge
        if (left + dropdownRect.width > viewportWidth) {
          left = Math.max(0, viewportWidth - dropdownRect.width);
        }

        // Calculate top position
        let top;
        if (showBelow) {
          top = buttonRect.bottom + window.scrollY + 8; // Add 8px gap
          // Check if dropdown extends beyond bottom of viewport
          if (top + dropdownRect.height > viewportHeight + window.scrollY) {
            top = viewportHeight + window.scrollY - dropdownRect.height - 8;
          }
        } else {
          top = buttonRect.top + window.scrollY - dropdownRect.height - 8; // Add 8px gap above
          // Check if dropdown extends beyond top of viewport
          if (top < window.scrollY) {
            top = window.scrollY + 8;
          }
        }

        // Apply the calculated position
        dropdownContainerRef.current.style.left = `${left}px`;
        dropdownContainerRef.current.style.top = `${top}px`;
        dropdownContainerRef.current.style.width = `${Math.max(
          buttonRect.width,
          256
        )}px`; // min-w-64 = 256px
      };

      // Initial position update
      updatePosition();

      // Update position on scroll and resize
      const handleScroll = () => {
        requestAnimationFrame(updatePosition);
      };

      // Add scroll event listeners
      window.addEventListener("scroll", handleScroll, true);
      window.addEventListener("resize", handleScroll);

      // Cleanup
      return () => {
        window.removeEventListener("scroll", handleScroll, true);
        window.removeEventListener("resize", handleScroll);
      };
    }
  }, [isOpen, showYearsList]);

  useEffect(() => {
    if (selected) {
      setFromMonth(
        parseMonth(range ? selected?.from || selected?.start : null)
      );
      setToMonth(parseMonth(range ? selected?.to || selected?.end : null));
    }
  }, [selected]);

  useEffect(() => {
    if (!range) {
      const parsedMonth = parseMonth(selected);
      if (
        parsedMonth &&
        isMonthValid(parsedMonth.getFullYear(), parsedMonth.getMonth())
      ) {
        setSelectedMonth(parsedMonth);
        setCurrentYear(parsedMonth.getFullYear());
      }
    } else {
      const parsedFromMonth = parseMonth(selected?.from || selected?.start);
      const parsedToMonth = parseMonth(selected?.to || selected?.end);

      if (parsedFromMonth) {
        setFromMonth(parsedFromMonth);
        setSelectionMode(parsedToMonth ? "from" : "to");
        setCurrentYear(parsedFromMonth.getFullYear());
      }

      if (parsedToMonth) {
        setToMonth(parsedToMonth);
        if (selectionMode === "to") {
          setCurrentYear(parsedToMonth.getFullYear());
        }
      }
    }
  }, [selected, minDate, maxDate, range]);

  const handleMonthClick = (monthIndex) => {
    try {
      const newSelectedMonth = new Date(currentYear, monthIndex, 1);

      if (isMonthValid(currentYear, monthIndex)) {
        if (!range) {
          setTempSelectedMonth(newSelectedMonth);
          setSelectedMonth(newSelectedMonth);
          onChange(newSelectedMonth);
          setIsOpen(false);
        } else {
          if (selectionMode === "from") {
            if (toMonth && newSelectedMonth > toMonth) {
              setToMonth(null);
              setFromMonth(newSelectedMonth);
              setSelectionMode("to");
              onChange({ from: newSelectedMonth, to: null });
            } else {
              setFromMonth(newSelectedMonth);
              setSelectionMode("to");
              onChange({ from: newSelectedMonth, to: toMonth });
            }
          } else {
            setToMonth(newSelectedMonth);
            setSelectionMode("from");
            onChange({ from: fromMonth, to: newSelectedMonth });
            setIsOpen(false);
          }
          setTempSelectedMonth(newSelectedMonth);
        }
      }
    } catch (error) {
      console.error("Error creating month:", error);
    }
  };

  const handlePrevYear = () => {
    setCurrentYear(currentYear - 1);
  };

  const handleNextYear = () => {
    setCurrentYear(currentYear + 1);
  };

  const handleThisMonthClick = () => {
    const thisMonth = new Date();
    const normalizedThisMonth = new Date(
      thisMonth.getFullYear(),
      thisMonth.getMonth(),
      1
    );
    setTempSelectedMonth(normalizedThisMonth);
    setCurrentYear(thisMonth.getFullYear());

    if (!range) {
      setSelectedMonth(normalizedThisMonth);
      onChange(normalizedThisMonth);
    } else {
      if (selectionMode === "from") {
        setFromMonth(normalizedThisMonth);
        setSelectionMode("to");
        onChange({ from: normalizedThisMonth, to: toMonth });
      } else {
        setToMonth(normalizedThisMonth);
        setSelectionMode("from");
        onChange({ from: fromMonth, to: normalizedThisMonth });
      }
    }
    setIsOpen(false);
  };

  const handleDoneClick = () => {
    if (!range) {
      if (tempSelectedMonth) {
        setSelectedMonth(tempSelectedMonth);
        try {
          if (typeof onChange === "function") {
            onChange(tempSelectedMonth);
          }
        } catch (error) {
          console.error("Error in onChange handler:", error);
        }
      }
    } else {
      if (tempSelectedMonth) {
        if (selectionMode === "from") {
          setFromMonth(tempSelectedMonth);
          setSelectionMode("to");
          onChange({ from: tempSelectedMonth, to: toMonth });
        } else {
          setToMonth(tempSelectedMonth);
          setSelectionMode("from");
          onChange({ from: fromMonth, to: tempSelectedMonth });
          setIsOpen(false);
        }
      }

      if (selectionMode === "to" && fromMonth && !tempSelectedMonth) {
        setIsOpen(false);
      }
    }

    setIsOpen(false);
    setShowYearsList(false);
  };

  const handleClearClick = () => {
    if (!range) {
      setSelectedMonth(null);
      onChange(null);
    } else {
      setFromMonth(null);
      setToMonth(null);
      setSelectionMode("from");
      onChange({ from: null, to: null });
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;

      switch (e.key) {
        case "Escape":
          setIsOpen(false);
          break;
        case "ArrowLeft":
          if (!showYearsList) handlePrevYear();
          break;
        case "ArrowRight":
          if (!showYearsList) handleNextYear();
          break;
        case "Enter":
          if (showYearsList) {
            setShowYearsList(false);
            setIsOpen(true);
          }
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, showYearsList]);

  const renderMonths = () => {
    return months.map((month, index) => {
      const monthDate = new Date(currentYear, index, 1);
      const isCurrentMonth =
        monthDate.getMonth() === new Date().getMonth() &&
        monthDate.getFullYear() === new Date().getFullYear();

      const isBeforeMinDate =
        minDate &&
        monthDate < new Date(minDate.getFullYear(), minDate.getMonth(), 1);
      const isAfterMaxDate =
        maxDate &&
        monthDate > new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
      const isBeforeFromMonth =
        range && selectionMode === "to" && fromMonth && monthDate < fromMonth;

      const isFromMonth =
        range &&
        fromMonth &&
        monthDate.getMonth() === fromMonth.getMonth() &&
        monthDate.getFullYear() === fromMonth.getFullYear();

      const isToMonth =
        range &&
        toMonth &&
        monthDate.getMonth() === toMonth.getMonth() &&
        monthDate.getFullYear() === toMonth.getFullYear();

      const isInRange =
        range &&
        fromMonth &&
        toMonth &&
        monthDate > fromMonth &&
        monthDate < toMonth;

      const isSelectedMonth =
        !range &&
        tempSelectedMonth instanceof Date &&
        !isNaN(tempSelectedMonth) &&
        tempSelectedMonth.getMonth() === index &&
        tempSelectedMonth.getFullYear() === currentYear;

      return (
        <div
          key={index}
          className={`leading-none flex items-center justify-center rounded-lg cursor-pointer p-2 text-center hover:bg-primary hover:text-white transition-colors ${
            isSelectedMonth ? "bg-primary text-white" : ""
          } ${isFromMonth ? "bg-primary text-white" : ""} ${
            isToMonth ? "bg-primary text-white" : ""
          } ${isInRange ? "bg-primary/20" : ""} ${
            isCurrentMonth ? "border-[1px] border-primary" : ""
          } ${
            isBeforeMinDate || isAfterMaxDate || isBeforeFromMonth
              ? "text-gray-300 cursor-not-allowed hover:bg-transparent hover:text-gray-300"
              : ""
          } text-sm`}
          onClick={() =>
            !isBeforeMinDate &&
            !isAfterMaxDate &&
            !isBeforeFromMonth &&
            handleMonthClick(index)
          }
        >
          {month.slice(0, 3)}
        </div>
      );
    });
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        (dropdownRef.current && dropdownRef.current.contains(event.target)) ||
        (dropdownContainerRef.current &&
          dropdownContainerRef.current.contains(event.target))
      ) {
        return;
      }
      setIsOpen(false);
      setShowYearsList(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (!range) {
        setTempSelectedMonth(selectedMonth);
      } else {
        setTempSelectedMonth(selectionMode === "from" ? fromMonth : toMonth);
      }
    }
  }, [isOpen, selectedMonth, selectionMode, fromMonth, toMonth, range]);

  const formatMonth = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return "";
    try {
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
      });
    } catch (error) {
      console.error("Error formatting month:", error);
      return "";
    }
  };

  const formatMonthRange = () => {
    if (fromMonth && toMonth) {
      return `${formatMonth(fromMonth)} - ${formatMonth(toMonth)}`;
    } else if (fromMonth) {
      return `${formatMonth(fromMonth)} - Select end month`;
    } else {
      return placeholder;
    }
  };

  return (
    <div className="relative w-full min-w-32" ref={dropdownRef}>
      {/* MonthPicker Button */}
      <button
        ref={buttonRef}
        className={`w-full border flex justify-between items-center  ${
          sizeClasses[size]
        } ${fontSizeClasses[size]} ${rounded} 
        ${shadow ? "border-gray-50 inputShadow" : "border-gray-300"}
        ${
          disabled
            ? "border-neutrals-200 bg-neutrals-200 text-black cursor-not-allowed"
            : "bg-white hover:border-primary focus:border-primary focus:outline-none"
        }`}
        onClick={() => {
          if (showYearsList) {
            setShowYearsList(false);
          }
          setIsOpen(!isOpen);
        }}
        disabled={disabled}
      >
        <span
          className={`line-clamp-1 text-left ${
            (range ? fromMonth || toMonth : selectedMonth)
              ? "text-black"
              : "text-neutrals-500"
          }`}
        >
          {range
            ? formatMonthRange()
            : selectedMonth
            ? formatMonth(selectedMonth)
            : placeholder}
        </span>

        <span
          className={`material-icons transition-transform ${
            iconSizeClasses[size]
          } ${
            (range ? fromMonth || toMonth : selectedMonth)
              ? "cursor-pointer"
              : ""
          }
          ${
            disabled
              ? "bg-neutrals-200 text-black cursor-not-allowed"
              : "bg-white cursor-pointer"
          }
          `}
          onClick={(e) => {
            e.stopPropagation();
            if (range) {
              if (fromMonth || toMonth) {
                setFromMonth(null);
                setToMonth(null);
                setSelectionMode("from");
                onChange({ from: null, to: null });
              } else {
                setIsOpen((open) => !open);
              }
            } else {
              if (selectedMonth) {
                setSelectedMonth(null);
                onChange(null);
              } else {
                setIsOpen((open) => !open);
              }
            }
          }}
        >
          {(range ? fromMonth || toMonth : selectedMonth)
            ? "close"
            : "calendar_month"}
        </span>
      </button>

      {/* Month Picker Dropdown using Portal */}
      {isOpen &&
        createPortal(
          <div
            ref={dropdownContainerRef}
            style={{ position: "fixed" }}
            className="z-50 bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-68"
          >
            <div className="px-4 pt-3 flex justify-between items-center">
              <div className="w-full flex items-center justify-between gap-1 border-[1px] border-neutrals-50 p-1">
                <Button
                  type="icon"
                  color="black"
                  variant="text"
                  size="sm"
                  icon={"west"}
                  onClick={handlePrevYear}
                />
                <div className="px-3">
                  <Button
                    variant="text"
                    size="sm"
                    color="black"
                    title={currentYear.toString()}
                    onClick={() => {
                      if (showYearsList) {
                        setShowYearsList(false);
                        setIsOpen(true);
                      } else {
                        setShowYearsList(true);
                        setIsOpen(false);
                      }
                    }}
                  />
                </div>
                <Button
                  type="icon"
                  variant="text"
                  size="sm"
                  color="black"
                  icon={"east"}
                  onClick={handleNextYear}
                />
              </div>
            </div>

            {range && (
              <div className="px-4 pt-2">
                <div className="text-sm font-medium text-primary">
                  {selectionMode === "from"
                    ? "Select start month"
                    : "Select end month"}
                </div>
              </div>
            )}

            <div className="grid grid-cols-3 gap-2 px-4 py-4">
              {renderMonths()}
            </div>

            <hr />
            <div className="flex items-center justify-between px-4 py-4">
              <Button
                variant="text"
                color="black"
                title="Clear"
                onClick={handleClearClick}
              />
              <div className="flex items-center gap-2">
                <Button
                  variant="text"
                  color="black"
                  title="This Month"
                  onClick={handleThisMonthClick}
                />
                <Button title="Done" size="md" onClick={handleDoneClick} />
              </div>
            </div>
          </div>,
          document.querySelector(".select-root")
        )}

      {/* Year selection panel using Portal */}
      {showYearsList &&
        createPortal(
          <div
            ref={dropdownContainerRef}
            style={{ position: "fixed" }}
            className="z-50 p-4 bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-68"
          >
            <div className="flex justify-between gap-1 items-center mb-4">
              <Button
                type="icon"
                size="xs-sm"
                icon={"west"}
                onClick={() => setCurrentYear(currentYear - 9)}
              />
              <span className="font-medium">
                {currentYear - 4} - {currentYear + 4}
              </span>
              <Button
                type="icon"
                size="xs-sm"
                icon={"east"}
                onClick={() => setCurrentYear(currentYear + 9)}
              />
            </div>
            <div className="grid grid-cols-3 gap-4">
              {Array.from({ length: 9 }, (_, i) => currentYear - 4 + i).map(
                (year) => (
                  <Button
                    key={year}
                    title={year.toString()}
                    variant={currentYear === year ? "outlined" : "text"}
                    color={currentYear === year ? "primary" : "default"}
                    onClick={() => {
                      setCurrentYear(year);
                      setShowYearsList(false);
                      setIsOpen(true);
                    }}
                  />
                )
              )}
            </div>
          </div>,
          document.querySelector(".select-root")
        )}
    </div>
  );
};

export default CustomMonthPicker;
